import { Nullable, WithErrors } from "../../types";
import {
    PostSpirometryData,
    PostSpirometryDataFromAPI,
    PostSpirometryParameter,
    PreSpirometryData,
    PreSpirometryDataFromAPI,
} from "./types";

export const convertPreSpirometryDataFromAPI = (
    dataFromAPI: Nullable<PreSpirometryDataFromAPI>
): Nullable<WithErrors<PreSpirometryData>> => {
    return !dataFromAPI
        ? null
        : Object.entries(dataFromAPI).reduce((acc, [key, value]) => {
              return {
                  ...acc,
                  [key]: {
                      error_message: value.error_message,
                      measured: value.measured,
                      highLimit: value.high_limit,
                      lowLimit: value.low_limit,
                      percentOfPredicted: value.percent_of_predicted,
                      predicted: value.predicted,
                  },
              };
          }, {} as PreSpirometryData);
};

export const invertPreSpirometryData = (
    data: PreSpirometryData
): PreSpirometryDataFromAPI => {
    return Object.entries(data).reduce((acc, [key, value]) => {
        return {
            ...acc,
            [key]: {
                high_limit: value.highLimit,
                low_limit: value.lowLimit,
                measured: value.measured,
                percent_of_predicted: value.percentOfPredicted,
                predicted: value.predicted,
            },
        };
    }, {} as PreSpirometryDataFromAPI);
};

export const convertPostSpirometryDataFromAPI = (
    dataFromAPI: Nullable<PostSpirometryDataFromAPI>
): Nullable<WithErrors<PostSpirometryData>> => {
    return !dataFromAPI
        ? null
        : Object.entries(dataFromAPI).reduce((acc, [key, value]) => {
              return {
                  ...acc,
                  [key]: {
                      error_message: value.error_message,
                      measured: value.measured,
                      highLimit: value.high_limit,
                      lowLimit: value.low_limit,
                      prePostPercent: value.pre_post_percent,
                      threshold: value.threshold,
                      predicted: value.predicted,
                      status: value.status,
                      statusColor: value.status_color,
                  },
              };
          }, {} as PostSpirometryData);
};

export const invertPostSpirometryData = (
    data: PostSpirometryData
): PostSpirometryDataFromAPI => {
    return Object.entries(data).reduce(
        (acc, [key, value]: [key: string, value: PostSpirometryParameter]) => {
            return {
                ...acc,
                [key]: {
                    measured: value.measured,
                    parameter_name: value.parameterName,
                    label: value.parameterName,
                    pre_post_percent: value.prePostPercent,
                    threshold: value.threshold,
                    status: value.status,
                    status_color: value.statusColor,
                },
            };
        },
        {} as PostSpirometryDataFromAPI
    );
};
